import { MouseEventHandler, ReactNode } from 'react';
import View from '../view';
import { FelaExtend } from '../../../types/fela';

type ButtonProps = {
  children?: ReactNode;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  disabled?: boolean;
  extend?: FelaExtend;
  noBg?: boolean;
  noPadding?: boolean;
  smaller?: boolean;
};

const Button = ({ children, onClick, disabled, extend }: ButtonProps) => (
  <View
    as="button"
    type="button"
    onClick={disabled ? undefined : onClick}
    extend={[
      {
        border: 'none',
        background: 'transparent',
        cursor: disabled ? 'default' : 'pointer',
        padding: 0,
        font: 'inherit',
      },
      extend,
    ]}
  >
    {children}
  </View>
);

export default Button;
